/* JavaScript include for: Esri Home Page Slider*/
var includes = "",
    web_dir = "//webapps-cdn.esri.com/CDN/components/feature-slider/";

if (hostnameContains(['webappscdn-local'])) {
    web_dir = "//webappscdn-local/components/feature-slider/";
} else if (hostnameContains(['localhost','cmsdev', 'webapps-cdn-dev.esri.com'])) {
    web_dir = "//webapps-cdn-dev.esri.com/CDN/components/feature-slider/";
} else if (hostnameContains(['cmsqa', 'webapps-cdn-stg.esri.com'])) {
    web_dir = "//webapps-cdn-stg.esri.com/CDN/components/feature-slider/";
}

var scripts_dir = web_dir + "js/",
    scripts = [];

if (typeof jQuery == 'undefined') {
    scripts.push("//webapps-cdn.esri.com/jslibs/jquery/jquery-1.11.1.min.js");
}

if (typeof Craydent == 'undefined') {
    scripts.push("//webapps-cdn.esri.com/CDN/jslibs/craydent-latest.js");
}

scripts.push(
    "//webapps-cdn.esri.com/CDN/jslibs/lodash/lodash.2.4.1.min.js",
    "//webapps-cdn.esri.com/CDN/jslibs/q.js",
    "//webapps-cdn.esri.com/CDN/jslibs/hammer.min.js",
    scripts_dir + "esri-homepage-slider.js"
);

var styles_dir = web_dir + "css/",
    styles = [
        "esri-homepage-slider.css"
    ],
    script, style, sc, st,
    sc_len = scripts.length, st_len = styles.length;

//scripts
for (sc = 0; sc < sc_len; sc++) {
    script = scripts[sc];
    includes += '<script type="text/javascript" src="' + script + '"></script>';
}
//styles
for (st = 0; st < st_len; st++) {
    style = styles[st];
    includes += '<link href="' + styles_dir + style + '" rel="stylesheet" type="text/css">';
}

includes += '<!--[if lte IE 8]>';
includes += '<link href="' + styles_dir + 'esri-homepage-slider-ie8.css" rel="stylesheet" type="text/css">';
includes += '<![endif]-->';

includes += '<!--[if lte IE 7]>';
includes += '<link href="' + styles_dir + 'esri-homepage-slider-ie7.css" rel="stylesheet" type="text/css">';
includes += '<![endif]-->';

document.write(includes);


function hostnameContains(hosts) {
    for (var i = 0; i < hosts.length; i++) {
        if (location.hostname.indexOf(hosts[i]) > -1) {
            return true;
        }
    }
    return false;
}